import { render, staticRenderFns } from "./ExchangeFooter.vue?vue&type=template&id=6a3215f8&scoped=true&"
import script from "./ExchangeFooter.vue?vue&type=script&lang=js&"
export * from "./ExchangeFooter.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeFooter.vue?vue&type=style&index=0&id=6a3215f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3215f8",
  null
  
)

export default component.exports